__turbopack_context__.v({
  "clicked": "V1LiPW_clicked",
  "copy-link": "V1LiPW_copy-link",
  "heading": "V1LiPW_heading",
  "smaller": "V1LiPW_smaller",
  "tooltip": "V1LiPW_tooltip",
  "tooltip-text": "V1LiPW_tooltip-text",
});
